(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ConversationListController', ConversationListController);

    ConversationListController.$inject = ['$state', 'Conversation', 'ConversationSearch', 'ConversationCustom'];

    function ConversationListController($state, Conversation, ConversationSearch, ConversationCustom) {

        var vm = this;

        vm.conversationList = [];
        vm.loadAll = loadAll;
        vm.findStatusStyle = findStatusStyle;
        vm.getSeeStatusStyle = getSeeStatusStyle;

        loadAll();

        function loadAll() {
            vm.conversationList = ConversationCustom.getConversationByCurrentCompany().query();
        }

        function findStatusStyle(status) {
            return "conversation-status-" + status;
        }

        function getSeeStatusStyle(conversation) {
            if (conversation != null && conversation != undefined) {

                if (hasNotSeenMessages(conversation)) {
                    return "message-not-seen";
                }

            }

        }

        function hasNotSeenMessages(conv) {
            var result = false;
            if (conv != null && conv.messages != null && conv.messages.length > 0) {
                angular.forEach(conv.messages, function (msg) {
                    if (msg.senderType == "CUSTOMER" && msg.status == "NEW") {
                        result = true;
                    }

                });

            }

            return result;
        }
    }
})();
